import { render, staticRenderFns } from "./cHub.vue?vue&type=template&id=4554b5d4&scoped=true"
import script from "./cHub.vue?vue&type=script&lang=js"
export * from "./cHub.vue?vue&type=script&lang=js"
import style0 from "./cHub.vue?vue&type=style&index=0&id=4554b5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554b5d4",
  null
  
)

export default component.exports